<template>
    <div class="position-relative">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle nav-link" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <!--                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 21 23"><g><g><g><g/><g><g><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M19.797 22.247v0-2.395a4.792 4.792 0 0 0-4.792-4.792H5.422A4.792 4.792 0 0 0 .63 19.852v2.395"/></g><g><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" stroke-width="1.5" d="M10.212 10.273a4.792 4.792 0 1 0 0-9.583 4.792 4.792 0 0 0 0 9.583z"/></g></g></g></g></g></svg>                -->
<!--                <img class="d-none d-lg-inline-block" src="https://cdn03.plentymarkets.com/x8owdo162lc9/frontend/icons/header-user.png" alt="user">-->
<!--                <img class="d-lg-none" src="https://cdn03.plentymarkets.com/x8owdo162lc9/frontend/icons/header-user-mobile.png" alt="user">-->
<!--                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>-->
                <i aria-hidden="true" class="fa fa-user"></i>

            </a>
            <div class="dropdown-menu">
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="$ceres.urls.myAccount" class="nav-link">
                        <span class="d-sm-inline">{{ $translate("Ceres::Template.loginMyAccount") }}</span>

                    </a>
                    <a href="#" class="nav-link" v-logout>
                        <span class="d-sm-inline"> {{ $translate("Ceres::Template.loginLogout") }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn" class="dropdown">
            <a href="#" class="dropdown-toggle nav-link" :class="{'nav-link--active' : getTemplate }" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <i aria-hidden="true" class="fa fa-user"></i>
            </a>
            <div class="dropdown-menu">
                <a class="nav-link" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();">
                    <span class="d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
                </a>
                <hr>
                <a class="nav-link" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'"  @click="createRegisterModal(); unmarkInputFields();" v-if="showRegistration">
                    <span class="d-sm-inline">{{ $translate("Ceres::Template.loginRegister") }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import ApiService from "ceres/app/services/ApiService";
    import ValidationService from "ceres/app/services/ValidationService";
    import { isDefined } from "ceres/app/helper/utils";
    import { mapGetters, mapActions } from "vuex";

    export default {
        props: {
            showRegistration: {
                type: Boolean,
                default: true
            },
            showLogin: {
                type: Boolean,
                default: true
            }
        },

        data()
        {
            return {
                isLogin: App.templateType === "login",
                isRegister: App.templateType === "register"
            };
        },

        computed: {
            ...mapGetters([
                "username",
                "isLoggedIn"
            ]),

            getTemplate() {
                return App.templateType === "login"
            }
        },

        methods: {

            unmarkInputFields()
            {
                ValidationService.unmarkAllFields($("#login"));
                ValidationService.unmarkAllFields($("#registration"));
            },

            createLoginModal()
            {
                this.loadComponent("login-modal");

            },

            createRegisterModal()
            {
                this.loadComponent("register-modal");
            },

            ...mapActions([
                "loadComponent"
            ])
        }
    }
</script>
